__turbopack_context__.v({
  "bullet": "CollaborationProcessSection-module-scss-module__iSk2fG__bullet",
  "bulletActive": "CollaborationProcessSection-module-scss-module__iSk2fG__bulletActive",
  "container": "CollaborationProcessSection-module-scss-module__iSk2fG__container",
  "customPagination": "CollaborationProcessSection-module-scss-module__iSk2fG__customPagination",
  "description": "CollaborationProcessSection-module-scss-module__iSk2fG__description",
  "header": "CollaborationProcessSection-module-scss-module__iSk2fG__header",
  "link": "CollaborationProcessSection-module-scss-module__iSk2fG__link",
  "mobileCards": "CollaborationProcessSection-module-scss-module__iSk2fG__mobileCards",
  "slide": "CollaborationProcessSection-module-scss-module__iSk2fG__slide",
  "sliderWrapper": "CollaborationProcessSection-module-scss-module__iSk2fG__sliderWrapper",
  "swiper": "CollaborationProcessSection-module-scss-module__iSk2fG__swiper",
});
